export default {"src":"/_next/static/media/trash.13228d90.svg","height":512,"width":513};